import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ProductContext } from '../context/productContext';

const Shop = () => {

    const { productsData } = useContext(ProductContext)

    const renderSkeleton = () => {
        return (
            <div className="col-md-6 col-lg-4">
                <div className="product-card skeleton-card">
                    <div className="skeleton-image shimmer"></div>
                    <div className="skeleton-content">
                        <div className="skeleton-title shimmer"></div>
                        <div className="skeleton-line shimmer"></div>
                        <div className="skeleton-line shimmer"></div>
                        <div className="skeleton-line short shimmer"></div>
                        <div className="skeleton-button shimmer"></div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <section className="shop-pg-sc">
            <div className="container-fluid ps-5 pe-5">
                <div className="row">
                    <div className="col-md-12">
                        <div className="shedule-head">
                            <div className="un-head wow bounceInUp">
                                <h3>SHOP</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row wow slideInLeft">
                    {!productsData || productsData.length === 0
                        ? Array(5).fill(0).map((_, i) => (
                            <React.Fragment key={i}>
                                {renderSkeleton()}
                            </React.Fragment>
                        ))
                        : productsData.map((product) => (
                            <div key={product.product_id} className="col-md-6 col-lg-4">
                                <div className="shop-card">
                                    <div className="shop-image">
                                        <img src={`https://roughradio.demo-customproject.com/backend/${product.pi_image_path}${product.pi_image}`} alt={product.product_name} />
                                    </div>
                                    <div className="shop-content">
                                        <h6>{product.product_name}</h6>
                                        <p className="product-price">£{Number(product.product_price).toFixed(2)}</p>
                                        <p className="product-description">{product.product_desc}</p>
                                        <Link to={`/product/${product.product_slug}`} className="shop-btn">
                                            View Details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </section>
    );
};

export default Shop;
